// 下載中心的共用狀態（移植自 crm/src/pages/tasks/exportOrders.js）：
//   - 清單：TanStack Query（EXPORT_ORDERS_KEY），取消、完成事件都直接改快取，不另存一份
//   - 紅點：使用者成功發起一筆匯出／報告 → 亮；打開下載中心 → 滅。純前端標記
//   - 完成通知：即時推播 export.order.finished → 就地更新該列；成功時 toast + 亮紅點
// 其他頁面發起匯出成功後呼叫 notifyExportCreated()（舊版同名函式）。
import { useSyncExternalStore } from 'react'
import { events, EXPORT_ORDER_FINISHED } from '@/lib/listener'
import { queryClient } from '@/app/queryClient'
import { addToast } from '@/components/ui/Toast'
import { t } from '@/i18n'

export const EXPORT_ORDERS_KEY = ['export-orders']

export const STATUS = { PROCESSING: 1, RETRYING: 2, FAILED: 3, SUCCESS: 4, CANCELED: 5 }

let hasNew = false
const listeners = new Set()
function setHasNew(value) {
  hasNew = value
  listeners.forEach((fn) => fn())
}

export function notifyExportCreated() {
  setHasNew(true)
}

export function clearExportNotification() {
  setHasNew(false)
}

export function useHasNewExport() {
  return useSyncExternalStore(
    (fn) => {
      listeners.add(fn)
      return () => listeners.delete(fn)
    },
    () => hasNew,
  )
}

// 就地更新快取裡的某一列（不在清單裡就忽略）
export function updateOrderInCache(orderNo, patch) {
  queryClient.setQueryData(EXPORT_ORDERS_KEY, (res) => {
    if (!res?.data) return res
    return { ...res, data: res.data.map((o) => (o.order_no === orderNo ? { ...o, ...patch } : o)) }
  })
}

function onFinished(payload) {
  if (!payload?.order_no) return
  updateOrderInCache(payload.order_no, payload)
  if (payload.finished && payload.status === STATUS.SUCCESS) {
    setHasNew(true)
    addToast({ level: 'success', message: `${payload.file_name} ${t('app', 'Export Finished')}` })
  }
}

// 模組層訂閱（同舊版）：整個 App 只訂一次，下載中心沒打開時也要收
events.on(EXPORT_ORDER_FINISHED, onFinished)
if (import.meta.hot) {
  import.meta.hot.dispose(() => events.off(EXPORT_ORDER_FINISHED, onFinished))
}
